import { dataCivil, deISO, paraISO, somaDias, ultimoDiaDoMes } from "./data.js";
import { formatBRL } from "./dinheiro.js";
/**
 * Assinatura do servico.
 *
 * O produto e gratuito para organizar e pago para EMITIR: a guia e o arquivo
 * anual sao os dois artefatos que valem dinheiro, e sao os dois que travam.
 * Registrar aluguel, guardar comprovante e responder pergunta continuam
 * funcionando sem pagamento, porque bloquear isso faria o mes passar em
 * branco justamente para quem ja esta atrasado, e o dado perdido nao volta.
 *
 * Todo o dinheiro e do Asaas: nenhum dado de cartao passa por aqui.
 */
/**
 * PRECO POR FAIXA (Tiago, 31/08/2026):
 *  - abaixo de 5 mil: R$ 34,90 fixos;
 *  - de 5 mil a 49.999, degraus de 5 em 5 mil: 1% do PISO da faixa
 *    (5 mil -> R$ 50, 10 mil -> R$ 100 ... 45 mil -> R$ 450);
 *  - a partir de 50 mil: 2% da SOMA, linear, sem teto.
 * Fronteiras inclusivas. Reavaliado quando contrato muda, nunca mes a mes
 * (mensalidade que flutua sozinha gera desconfianca e suporte).
 */
export const PISOS_DE_FAIXA = [
    500_000, 1_000_000, 1_500_000, 2_000_000, 2_500_000,
    3_000_000, 3_500_000, 4_000_000, 4_500_000,
];
/** Onde a escada de degraus termina e o linear de 2% comeca. */
export const LIMIAR_DOIS_POR_CENTO = 5_000_000;
export function mensalidadePara(somaContratos) {
    if (somaContratos >= LIMIAR_DOIS_POR_CENTO) {
        return Math.round((somaContratos * 2) / 100);
    }
    let piso = 0;
    for (const p of PISOS_DE_FAIXA) {
        if (somaContratos >= p)
            piso = p;
        else
            break;
    }
    return piso === 0 ? 3_490 : Math.round(piso / 100);
}
/**
 * A base da faixa: soma BRUTA mensal dos contratos ativos. O melhor numero
 * conhecido de cada imovel, nesta ordem: o total pago confirmado (padrao
 * aprendido), o aluguel do contrato, o esperado do onboarding.
 */
export function somaContratos(imoveis) {
    return imoveis.reduce((soma, i) => soma + (i.padraoMensal?.totalPago ?? i.aluguelContrato ?? i.aluguelEsperado), 0);
}
/** Preco da menor faixa, para copy "a partir de". */
export const MENSALIDADE_MINIMA = mensalidadePara(0);
export const DIAS_DE_TRIAL = 30;
export const VERSAO_PRECOS_ASSINATURA = "anual-mensal-v1";
/** Mesma oferta para a vitrine, a tela Conta e o servidor de cobrança. */
export function precosAssinatura(soma) {
    const anualPorMes = mensalidadePara(soma);
    const mensal = soma < 500_000 ? 4_990 : Math.round(anualPorMes * 1.4);
    const totalAnual = anualPorMes * 12;
    return { anualPorMes, mensal, totalAnual, economiaAnual: mensal * 12 - totalAnual };
}
/** Ausência da versão identifica assinaturas mensais anteriores à nova oferta. */
export function valorRecorrentePara(soma, assinatura) {
    if (assinatura?.ciclo === "anual")
        return precosAssinatura(soma).totalAnual;
    return assinatura?.versaoPreco === VERSAO_PRECOS_ASSINATURA
        ? precosAssinatura(soma).mensal : mensalidadePara(soma);
}
/** Fim do trial: o gravado, ou 30 dias do cadastro para quem e anterior a cobranca. */
export function fimDoTrial(criadoEm, a) {
    if (a?.trialAte)
        return a.trialAte;
    return paraISO(somaDias(deISO(criadoEm.slice(0, 10)), DIAS_DE_TRIAL));
}
/**
 * Decide se pode emitir. Compara strings ISO de proposito: elas ordenam
 * lexicograficamente e nao carregam fuso, e fuso aqui seria a diferenca entre
 * cobrar e nao cobrar no dia da virada.
 *
 * Um pagamento em maos vale ate o fim do periodo mesmo depois de cancelar:
 * quem pagou o mes tem o mes.
 */
export function acessoPago(usuario, hoje) {
    const a = usuario.assinatura;
    /*
     * CONTA CORTESIA (Tiago, 01/09): usuarios que o dono decidiu nunca cobrar
     * (familia, testes). Flag setada DIRETO no Firestore pelo admin — sem UI,
     * sem callable — e honrada aqui, o unico portao de acesso pago do sistema.
     */
    if (usuario.cortesia)
        return { liberado: true, motivo: "cortesia" };
    if (a?.pagoAte && a.pagoAte >= hoje) {
        return { liberado: true, motivo: "pago", ate: a.pagoAte };
    }
    const trial = fimDoTrial(usuario.criadoEm, a);
    if (a?.status !== "cancelada" && hoje <= trial) {
        return { liberado: true, motivo: "trial", ate: trial };
    }
    return { liberado: false, motivo: a ? "vencida" : "sem_assinatura" };
}
/**
 * Ate quando o pagamento de uma cobranca cobre o servico: o mesmo dia do mes
 * seguinte, preso ao ultimo dia quando ele nao existe (31/01 vira 28/02).
 */
export function cobreAte(vencimento, ciclo = "mensal") {
    const d = deISO(vencimento);
    const ano = ciclo === "anual" || d.mes === 12 ? d.ano + 1 : d.ano;
    const mes = ciclo === "anual" ? d.mes : d.mes === 12 ? 1 : d.mes + 1;
    const ultimo = ultimoDiaDoMes(ano, mes).dia;
    return paraISO(dataCivil(ano, mes, Math.min(d.dia, ultimo)));
}
/** Data da primeira cobranca: o dia seguinte ao fim do periodo gratuito. */
export function primeiroVencimento(trialAte) {
    return paraISO(somaDias(deISO(trialAte), 1));
}
/**
 * O que o agente responde quando a acao pedida e paga e o acesso acabou.
 *
 * Diz primeiro que o dado foi guardado: a pessoa precisa saber que nao perdeu
 * o mes, senao o pedido de pagamento soa como refem.
 */
export function mensagemAssinaturaNecessaria(destino, mensalidade, assinatura) {
    return ("Guardei tudo, e seus lançamentos continuam aqui.\n\n" +
        "A emissão da guia e o arquivo da declaração entram na assinatura, e seu " +
        "mês grátis terminou. " +
        (assinatura?.assinaturaAsaas && assinatura.status !== "cancelada"
            ? `Seu plano ${assinatura.ciclo ?? "mensal"} custa ${formatBRL(mensalidade)} por ${assinatura.ciclo === "anual" ? "ano" : "mês"}.\n\n`
            : "Na Conta, escolha entre o anual com desconto e o mensal. O valor total aparece antes de assinar.\n\n") +
        (destino.link ? `Para liberar agora: ${destino.link}` : `Para assinar: ${destino.app}`));
}
//# sourceMappingURL=assinatura.js.map